/** An API call that failed. Status 0: the server could not be reached. */
export class ApiError extends Error {
  /** `body`: the error response as parsed, for the few routes that say more than a message. */
  constructor(public status: number, message: string, public body: unknown = undefined) {
    super(message);
  }
  get offline() {
    return this.status === 0;
  }
}
